import { slideUp, slideDown } from 'es6-slide-up-down';

export default class SlideUpDown {
  constructor (slideUpDownElem, addOpenEventElem, addCloseEventElem) {
    this.slideUpDownElem = slideUpDownElem;
    this.addCloseEventElem = addCloseEventElem;

    addOpenEventElem.addEventListener('click', this.openSlideEvent.bind(this));
    addCloseEventElem.addEventListener('click', this.closeSlideEvent.bind(this));
  }

  openSlideEvent (event) {
    event.preventDefault();
    const slideDownAnimationMilliSecond = 400;

    if (this.addCloseEventElem.style.display === 'block') {
      return false;
    }

    slideDown(this.slideUpDownElem, {
      duration: slideDownAnimationMilliSecond
    });

    setTimeout(function () {
      this.addCloseEventElem.style.display = 'block';
    }.bind(this), slideDownAnimationMilliSecond);
  }

  closeSlideEvent (event) {
    event.preventDefault();
    const slideUpAnimationMilliSecond = 400;

    this.addCloseEventElem.style.display = 'none';
    slideUp(this.slideUpDownElem, {
      duration: slideUpAnimationMilliSecond
    });
  }
}
